import React from 'react';
import { testimonials } from '../data/mock';
import { Quote } from 'lucide-react';

const Testimonials = () => {
  return (
    <section id="testimonials" style={{ background: 'var(--bg-primary)', padding: '100px 7.6923%', borderTop: '1px solid var(--border-subtle)' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2 className="display-large" style={{ marginBottom: '20px' }}>What Our Students Say</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
            Real stories from successful graduates
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '40px' }}>
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} style={{ background: 'var(--bg-secondary)', padding: '40px', border: '1px solid var(--border-subtle)', position: 'relative', transition: 'all 0.4s ease-in-out', overflow: 'hidden' }} className="dark-hover">
              {/* Background image with overlay */}
              <div style={{ position: 'absolute', inset: 0, opacity: 0.05, backgroundImage: `url(${testimonial.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }} />
              
              <Quote size={40} style={{ color: 'var(--brand-primary)', opacity: 0.3, position: 'relative', marginBottom: '20px' }} />
              <p className="body-medium" style={{ color: 'var(--text-secondary)', marginBottom: '24px', lineHeight: 1.7, position: 'relative' }}>
                "{testimonial.text}"
              </p>
              <div style={{ position: 'relative' }}>
                <h4 className="heading-3" style={{ marginBottom: '4px' }}>{testimonial.name}</h4>
                <p className="body-small" style={{ color: 'var(--text-muted)' }}>{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;